import React from 'react'
import LanguageSwitcher from 'components/LanguageSwitcher'
import { useI18n } from 'i18n'

// Dark brand backdrop + white card shared by login, signup and email verification.
const AuthLayout = ({ subtitle, onSubmit, footer, wide = false, children }) => {
  const { t } = useI18n()
  return (
    <div className='relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-ink px-4 py-16'>
      <div aria-hidden className='bg-grid absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]' />
      <div aria-hidden className='absolute -top-40 right-0 h-[32rem] w-[32rem] rounded-full bg-brand/40 blur-3xl' />
      <div className='absolute right-4 top-4 z-10'><LanguageSwitcher /></div>
      <form onSubmit={onSubmit} noValidate={false}
        className={`relative w-full ${wide ? 'max-w-md' : 'max-w-sm'} rounded-2xl bg-white p-6 shadow-2xl shadow-black/40 sm:p-8`}>
        <div className='mb-6 text-center'>
          <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt='' width='56' height='56' className='mx-auto h-14 w-14' />
          <h1 className='mt-3 text-xl font-bold'>{t('app.name')}</h1>
          <p className='text-xs font-medium text-slate-500'>{t('app.descriptor')}</p>
          {subtitle && <p className='mt-3 text-sm text-slate-500'>{subtitle}</p>}
        </div>
        {children}
      </form>
      {footer && <div className='relative mt-6 text-center text-sm text-white/70'>{footer}</div>}
    </div>
  )
}

export const authInputClass = 'w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand focus:outline-none'
export const authLabelClass = 'mb-1 block text-sm font-medium text-slate-600'
export const authButtonClass = 'w-full rounded-lg bg-accent px-4 py-2.5 text-sm font-semibold text-ink hover:bg-accent-600 disabled:cursor-not-allowed disabled:opacity-50'

export default AuthLayout
